<template>
	<!-- 协议客户管理 -->
	<section>
		<!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true" :model="filters">
				<el-form-item>
					<el-input v-model="filters.guestComName" placeholder="客户名称"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" v-on:click="guestCompanyList">查询</el-button>
				</el-form-item>
				<el-form-item v-if="!bquery">
					<el-button type="success" v-on:click="handleAddbzhFile">新增协议客户</el-button>
				</el-form-item>
			</el-form>
		</el-col>

		<!--列表 fileUrl,fileName-->
		<el-table :data="comguestlist" highlight-current-row v-loading="listLoading"  style="width: 100%;">
			<el-table-column prop="guestComName" label="客户名称" min-width="200" align="center">
			</el-table-column>

			<el-table-column prop="guestDate" label="协议签订时间" align="center"  min-width="150">
		 	</el-table-column>
			<el-table-column prop="guestGoods" label="物品名称"  align="center" min-width="150">
		 	</el-table-column>

			<el-table-column v-if="!bquery" prop="guestCode" label="信用代码"  align="center" min-width="150">
		 	</el-table-column>
			<el-table-column v-if="!bquery" prop="guestName" label="法人或寄件人姓名" align="center"  min-width="120">
			</el-table-column>
			<el-table-column v-if="!bquery" prop="guestWid" label="法人或寄件人身份证号" align="center"  min-width="150">
		 	</el-table-column>
			<el-table-column v-if="!bquery" prop="guestPhone" label="法人或寄件人电话" align="center"  min-width="120">
		 	</el-table-column>
			
			<el-table-column  v-if="!bquery" label="操作"  align="left" width="400">
				<template slot-scope="scope">
					<el-button type="primary" size="small" @click="handleFileShow(scope.$index, scope.row)">查看协议</el-button>
					<el-button type="primary" size="small" @click="handleWidNoShow(scope.$index, scope.row)">查看证件</el-button>
					<el-button type="primary" size="small" @click="updateFileShow(scope.$index, scope.row)">更新附件</el-button>
					<el-button type="danger" size="small" @click="handleGuestDel(scope.$index, scope.row)">删除</el-button>
				</template>
			</el-table-column>
		</el-table>

		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<el-pagination layout="total,prev, pager, next" @current-change="handleCurrentChange" :page-size="20" :total="total" style="float:right;">
			</el-pagination>
		</el-col>

		
		<!--显示PDF-->
		<el-dialog :title="pdfFileName" v-model="pdfVisible" :close-on-click-modal="false" >
			<el-form>
				<iframe :src="pdfSrc" frameborder="0" style="width: 100%; height: 500px"></iframe>
			</el-form>
		</el-dialog>

		<!--新增协议客户-->
		<el-dialog title="新增协议客户" v-model="guestFormVisible" :close-on-click-modal="false" >
			<el-form :label-position="labelPosition" :model="guestForm" label-width="210px" :rules="guestFormRules" ref="guestForm">
				<el-form-item label="客户名称" prop="guestComName">
					<el-input placeholder="请输入客户名称" v-model="guestForm.guestComName" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item label="信用代码" prop="guestCode">
					<el-input placeholder="请输入信用代码" v-model="guestForm.guestCode" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item label="法人或寄件人姓名" prop="guestName">
					<el-input placeholder="请输入法人或寄件人姓名" v-model="guestForm.guestName" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item label="法人或寄件人身份证号" prop="guestWid">
					<el-input placeholder="请输入法人或寄件人身份证号" v-model="guestForm.guestWid" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item label="法人或寄件人电话" prop="guestPhone">
					<el-input placeholder="请输入法人或寄件人电话" v-model="guestForm.guestPhone" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item label="物品名称" prop="guestGoods">
					<el-input placeholder="请输入物品名称" v-model="guestForm.guestGoods" auto-complete="off"></el-input>
				</el-form-item>

				<el-form-item label="协议签订时间" prop="guestDate">
					<el-date-picker v-model="guestForm.selGuestDate" type="date" placeholder="选择日期" value-format="yyyy-MM-dd" format="yyyy-MM-dd"></el-date-picker>
				</el-form-item>

				<el-form-item label="上传协议文件" >
					<div>
						<input ref="upLoadRef" type="file" @change.stop="handleFileUpload">
						<button  v-show="uploadstart" @click.stop.prevent="uploadXyFile">上传</button>
					</div>
				</el-form-item>

				<el-form-item label="上传寄件人或法人有效身份证件" >
					<div>
						<input ref="upLoadRefWid" type="file" @change.stop="handleFileUploadWid">
						<button  v-show="uploadstartWid" @click.stop.prevent="uploadWidFile">上传</button>
					</div>
				</el-form-item>
				<!-- <el-form-item label="文件名称" prop="fileName">
					<el-input placeholder="请输入文件名称" v-model="guestForm.fileName" auto-complete="off"></el-input>
				</el-form-item> -->
			</el-form>
						
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="guestFormVisible = false">取消</el-button>
				<el-button type="primary" @click.native="addcomGuest" :loading="fileLoading">保存</el-button>
			</div>
		</el-dialog>

		<!--更新客户证件-->
		<el-dialog title="更新协议客户附件" v-model="guestFormUpdateVisible" :close-on-click-modal="false" >
			<el-form :label-position="labelPosition" :model="guestFormUpdate" label-width="210px" :rules="guestFormUpdateRules" ref="guestFormUpdate">
				<el-form-item label="客户名称" prop="guestComName">
					<el-input placeholder="请输入客户名称" v-model="guestFormUpdate.guestComName" auto-complete="off" :disabled="true"></el-input>
				</el-form-item>
				<!-- <el-form-item label="信用代码" prop="guestCode">
					<el-input placeholder="请输入信用代码" v-model="guestForm.guestCode" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item label="法人或寄件人姓名" prop="guestName">
					<el-input placeholder="请输入法人或寄件人姓名" v-model="guestForm.guestName" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item label="法人或寄件人身份证号" prop="guestWid">
					<el-input placeholder="请输入法人或寄件人身份证号" v-model="guestForm.guestWid" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item label="法人或寄件人电话" prop="guestPhone">
					<el-input placeholder="请输入法人或寄件人电话" v-model="guestForm.guestPhone" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item label="物品名称" prop="guestGoods">
					<el-input placeholder="请输入物品名称" v-model="guestForm.guestGoods" auto-complete="off"></el-input>
				</el-form-item>

				<el-form-item label="协议签订时间" prop="guestDate">
					<el-date-picker v-model="guestForm.selGuestDate" type="date" placeholder="选择日期" value-format="yyyy-MM-dd" format="yyyy-MM-dd"></el-date-picker>
				</el-form-item> -->

				<el-form-item label="更新协议文件" >
					<div>
						<input ref="newupLoadRef" type="file" @change.stop="newhandleFileUpload">
						<button  v-show="newuploadstart" @click.stop.prevent="newuploadXyFile">上传</button>
					</div>
				</el-form-item>

				<el-form-item label="更新寄件人或法人有效身份证件" >
					<div>
						<input ref="newupLoadRefWid" type="file" @change.stop="newhandleFileUploadWid">
						<button  v-show="newuploadstartWid" @click.stop.prevent="newuploadWidFile">上传</button>
					</div>
				</el-form-item>

			</el-form>
						
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="guestFormUpdateVisible = false">取消</el-button>
				<el-button type="primary" @click.native="updatecomGuest" :loading="fileLoadingUpdate">提交</el-button>
			</div>
		</el-dialog>

	</section>
</template>

<script>
	import axios from 'axios';
	import { companyGuestPageList,addCompanyGuest,updateCompanyGuest} from '../../api/api';

	export default {
		data() {
			return {
				objectId:0, //当前登录的用户id，新增会用到
				coId:0, //当前登录的用户企业id

				bquery:false,//管理员权限

				filters: {
					guestComName: '',
				},
				comguestlist: [],
				total: 0,
				page: 1,
				listLoading: false,

			
				//新增文件
				labelPosition: 'right',

				imageFile: null,
				uploadstart:true,

				imageFileWid: null,
				uploadstartWid:true,

				guestFormVisible: false, 
				fileLoading: false,
				guestFormRules: {
					guestComName: [{ required: true, message: "请输入客户名称", trigger: "blur" }],
					guestName: [{ required: true, message: "请输入法人或寄件人姓名", trigger: "blur" }],
					guestPhone: [{ required: true, message: "请输入法人或寄件人电话", trigger: "blur" }],
					guestWid: [{ required: true, message: "请输入法人或寄件人身份证号", trigger: "blur" }],
					guestGoods: [{ required: true, message: "请输入物品名称", trigger: "blur" }],
					guestDate: [{ required: true, message: "请选择协议签订时间", trigger: "blur" }]
				},
				
				guestForm: {
					createUserId:0,
					coId:0,
					guestComName:"",
					guestName:"",
					guestPhone:"",
					guestWid:"",
					guestGoods:"",
					guestCode:"",
					fileUrl:"",	
					fileName:"",	
					widUrl:"",	
					widName:"",
						
					guestDate:'',
					selGuestDate:null,	
				},

				// 显示pdf
				pdfVisible: false, 
				pdfSrc: '', // 将从后台获取到的 PDF 文件地址赋值给这个字段
				pdfFileName:"",
				// 正式地址
				filebaseurl:"https://aqjg.ycsyzglj.com/",

				//更新用户证件信息
				guestFormUpdateVisible: false, 
				fileLoadingUpdate: false,
				guestFormUpdateRules: {
					// guestComName: [{ required: true, message: "请输入客户名称", trigger: "blur" }],
					// guestName: [{ required: true, message: "请输入法人或寄件人姓名", trigger: "blur" }],
					// guestPhone: [{ required: true, message: "请输入法人或寄件人电话", trigger: "blur" }],
					// guestWid: [{ required: true, message: "请输入法人或寄件人身份证号", trigger: "blur" }],
					// guestGoods: [{ required: true, message: "请输入物品名称", trigger: "blur" }],
					// guestDate: [{ required: true, message: "请选择协议签订时间", trigger: "blur" }]
				},
				guestFormUpdate: {
					guestId:0,
					guestComName:"",
					// guestName:"",
					// guestPhone:"",
					// guestWid:"",
					// guestGoods:"",
					// guestCode:"",
					fileUrl:"",	
					fileName:"",	
					widUrl:"",	
					widName:"",
						
					// guestDate:'',
					// selGuestDate:null,	
				},

				newimageFile: null,
				newuploadstart:true,

				newimageFileWid: null,
				newuploadstartWid:true,
			}
		},
		methods: {
	
			handleAddbzhFile: function () {
				this.guestFormVisible = true;
	
				this.guestForm.createUserId=this.objectId
				this.guestForm.coId=this.coId

				this.guestForm.guestComName=""
				this.guestForm.guestName=""
				this.guestForm.guestPhone=""
				this.guestForm.guestGoods=""
				this.guestForm.guestCode=""

				this.guestForm.guestWid=""
				this.guestForm.guestDate=''
				this.guestForm.selGuestDate=null

				this.uploadstart=true
				this.imageFile = null
				this.guestForm.fileName=""
				if (this.$refs.upLoadRef) {
					this.$refs.upLoadRef.value = '' // 置空input文件
				}

				this.uploadstartWid=true
				this.imageFileWid = null
				this.guestForm.widName=""
				if (this.$refs.upLoadRefWid) {
					this.$refs.upLoadRefWid.value = '' // 置空input文件
				}

			},
			handleFileUpload(event) {
				let filearr = event.target.files[0].name.split('.');

				if(filearr[1]=='pdf'){
					this.guestForm.fileName=filearr[0]
					this.imageFile = event.target.files[0];
				}else{
					this.guestForm.fileName=""
					this.imageFile = null;
					this.$message.error("请选择pdf格式的文件");
				}
				
			},
			uploadXyFile() {
				if(this.imageFile!=null){
					let formData = new FormData();
					formData.append('file', this.imageFile);
					formData.append('filetype', "xykh");
					formData.append('secondarydir', this.coId);
					axios.post('/yhpczl/mgr/v1/uploadFile', formData, {
						headers: {
						'Content-Type': 'multipart/form-data'
						}
					}).then(response => {					
						if (response.data.code==0) {
							this.guestForm.fileUrl = response.data.data.url;
							this.uploadstart=false
							this.$message.success("文件上传成功，请确认其他信息后点击保存");
						} else {
							this.$message.error("文件上传失败，请重新提交");
						}
					});
				}else{
					this.$message.error("请选择文件后再点击【上传】按钮");
				}
				
			},
			handleFileUploadWid(event) {
				let filearr = event.target.files[0].name.split('.');

				if(filearr[1]=='pdf'){
					this.guestForm.widName=filearr[0]
					this.imageFileWid = event.target.files[0];
				}else{
					this.guestForm.widName=""
					this.imageFileWid = null;
					this.$message.error("请选择pdf格式的文件");
				}
			},
			uploadWidFile() {
				if(this.imageFileWid!=null){
					let formData = new FormData();
					formData.append('file', this.imageFileWid);
					formData.append('filetype', "xykh");
					formData.append('secondarydir', this.coId);
					axios.post('/yhpczl/mgr/v1/uploadFile', formData, {
						headers: {
						'Content-Type': 'multipart/form-data'
						}
					}).then(response => {					
						if (response.data.code==0) {
							this.guestForm.widUrl = response.data.data.url;
							this.uploadstartWid=false
							this.$message.success("文件上传成功，请确认其他信息后点击保存");
						} else {
							this.$message.error("文件上传失败，请重新提交");
						}
					});
				}else{
					this.$message.error("请选择文件后再点击【上传】按钮");
				}
				
			},
			addcomGuest: function () {
				if(this.guestForm.selGuestDate!=null){
					this.guestForm.guestDate = this.guestForm.selGuestDate.toLocaleString();
				}
				if(this.guestForm.guestDate==""){
					this.$message.error("请选择协议签订时间");
				}else if(this.guestForm.fileUrl!=""&&this.guestForm.widUrl!=""){
					this.$refs.guestForm.validate((valid) => {
						if (valid) {
							this.$confirm('确认提交这个协议客户吗？', '提示', {}).then(() => {
							this.fileLoading = true;

							addCompanyGuest(this.guestForm).then((res) => {
									this.fileLoading = false;

									this.guestFormVisible = false;
									if(res.data.code==0){
										this.$message.success(res.data.message);
										//更新列表
										this.guestCompanyList();
									}
									else{
										this.$message.error(res.data.message);
									}
								});
							});
						}
					});
				}
				else{
					this.$message.error("请选择文件后，点击右侧的【上传】按钮，上传文件");
				}

			},	
			handleFileShow: function (index, row) {
				this.pdfSrc=this.filebaseurl+row.fileUrl
				this.pdfFileName="协议"
				this.pdfVisible=true
			},
			handleWidNoShow: function (index, row) {
				this.pdfSrc=this.filebaseurl+row.widUrl
				this.pdfFileName="证件"
				this.pdfVisible=true
			},
			handleGuestDel: function (index, row) {
				this.$confirm('确认删除这个协议客户吗？', '提示', {}).then(() => {
					let deleteparam={
						guestId:row.guestId,
						deleteStatus:"1"
					}
					updateCompanyGuest(deleteparam).then((res) => {
						if(res.data.code==0){
							this.$message.success(res.data.message);
							this.guestCompanyList();
						}
						else{
							this.$message.error(res.data.message);
						}
					});
				});	
			},

			handleCurrentChange(val) {				
				this.page = val;
				this.guestCompanyList();
			},
			//获取协议客户列表
			guestCompanyList() {

				let para = {
					page: this.page,
					pageSize:20,
					coId:"",
					objectId:this.objectId,
					guestComName:this.filters.guestComName,
				};


				if (!this.bquery) {
					para.coId=this.coId
				}

				this.listLoading = true;

				companyGuestPageList(para).then((res) => {
					if(res.data.code==0){
						this.total = res.data.data.total;
						this.comguestlist = res.data.data.list;
					}
					
					this.listLoading = false;

				});
			},
			updateFileShow: function (index, row) {
				this.guestFormUpdateVisible = true;
	
				this.guestFormUpdate.guestId=row.guestId
				this.guestFormUpdate.guestComName=row.guestComName
				
				this.guestFormUpdate.fileUrl="",	

				this.guestFormUpdate.widUrl="",	

				this.newuploadstart=true
				this.newimageFile = null
				this.guestFormUpdate.fileName=""
				if (this.$refs.newupLoadRef) {
					this.$refs.newupLoadRef.value = '' // 置空input文件
				}

				this.newuploadstartWid=true
				this.newimageFileWid = null
				this.guestFormUpdate.widName=""
				if (this.$refs.newupLoadRefWid) {
					this.$refs.newupLoadRefWid.value = '' // 置空input文件
				}

			},
			newhandleFileUpload(event) {
				let filearr = event.target.files[0].name.split('.');

				if(filearr[1]=='pdf'){
					this.guestFormUpdate.fileName=filearr[0]
					this.newimageFile = event.target.files[0];
				}else{
					this.guestFormUpdate.fileName=""
					this.newimageFile = null;
					this.$message.error("请选择pdf格式的文件");
				}
				
			},
			newuploadXyFile() {
				if(this.newimageFile!=null){
					let formData = new FormData();
					formData.append('file', this.newimageFile);
					formData.append('filetype', "xykh");
					formData.append('secondarydir', this.coId);
					axios.post('/yhpczl/mgr/v1/uploadFile', formData, {
						headers: {
						'Content-Type': 'multipart/form-data'
						}
					}).then(response => {					
						if (response.data.code==0) {
							this.guestFormUpdate.fileUrl = response.data.data.url;
							this.newuploadstart=false
							this.$message.success("文件上传成功，请确认其他信息后点击保存");
						} else {
							this.$message.error("文件上传失败，请重新提交");
						}
					});
				}else{
					this.$message.error("请选择文件后再点击【上传】按钮");
				}
				
			},
			newhandleFileUploadWid(event) {
				let filearr = event.target.files[0].name.split('.');

				if(filearr[1]=='pdf'){
					this.guestFormUpdate.widName=filearr[0]
					this.newimageFileWid = event.target.files[0];
				}else{
					this.guestFormUpdate.widName=""
					this.newimageFileWid = null;
					this.$message.error("请选择pdf格式的文件");
				}
			},
			newuploadWidFile() {
				if(this.newimageFileWid!=null){
					let formData = new FormData();
					formData.append('file', this.newimageFileWid);
					formData.append('filetype', "xykh");
					formData.append('secondarydir', this.coId);
					axios.post('/yhpczl/mgr/v1/uploadFile', formData, {
						headers: {
						'Content-Type': 'multipart/form-data'
						}
					}).then(response => {					
						if (response.data.code==0) {
							this.guestFormUpdate.widUrl = response.data.data.url;
							this.newuploadstartWid=false
							this.$message.success("文件上传成功，请确认其他信息后点击保存");
						} else {
							this.$message.error("文件上传失败，请重新提交");
						}
					});
				}else{
					this.$message.error("请选择文件后再点击【上传】按钮");
				}
				
			},
			updatecomGuest: function (index, row) {
				this.$confirm('确认更新协议客户的资料吗？', '提示', {}).then(() => {
					let newparam={
						guestId:this.guestFormUpdate.guestId,
						fileName:this.guestFormUpdate.fileName,
						fileUrl:this.guestFormUpdate.fileUrl,
						widName:this.guestFormUpdate.widName,
						widUrl:this.guestFormUpdate.widUrl,
					}
					updateCompanyGuest(newparam).then((res) => {

						this.fileLoadingUpdate = false;

						this.guestFormUpdateVisible = false;

						if(res.data.code==0){
							this.$message.success(res.data.message);
							this.guestCompanyList();
						}
						else{
							this.$message.error(res.data.message);
						}
					});
				});	
			},
		},
		mounted() {			
			let user = JSON.parse(sessionStorage.getItem('user'));
			this.coId = user.data.coId
			this.objectId = user.data.userId

			if (user.data.roleId=="4") {
				this.bquery=false
			} else {
				this.bquery=true
			}

			this.guestCompanyList();
		}
	}

</script>

<style scoped>
	
	
</style>


// WEBPACK FOOTER //
// enterpriseGuest.vue?6230f0d0